<template>
  <svg
    :class="customClass"
    :width="size"
    :height="size"
    :fill="color ? (hover ? hoverColor : color) : 'none'"
    :stroke="strokeColor ? (hover ? hoverColor : strokeColor) : 'none'"
    @mouseover="hover = true"
    @mouseleave="hover = false"
    v-html="renderedSvg"
  />
</template>

<script setup lang="ts">
import { ref, computed, defineProps } from 'vue';

const props = defineProps<{
  svgContent: string; // SVG 内容
  size?: string; // SVG 大小
  color?: string; // 默认填充颜色
  hoverColor?: string; // 悬停时的颜色
  strokeColor?: string; // 描边颜色
  customClass?: string; // 自定义 CSS 类
}>();

const hover = ref(false);

// 计算 SVG 的最终内容，并处理颜色
const renderedSvg = computed(() => {
  // 在 SVG 内容中替换 `fill` 属性以控制颜色
  const fillColor = hover.value ? props.hoverColor : props.color;

  return props.svgContent
    .replace(/width="[^"]*"/, `width="${props.size}"`)
    .replace(/height="[^"]*"/, `width="${props.size}"`)
    .replace(/fill="[^"]*"/, `fill="${fillColor}"`)
    .replace(/stroke="[^"]*"/, `fill="${props.strokeColor}"`);
});
</script>
